const SELECTOR = {
  OVERLAY: '.js-overlay',
  CONTAINER: '.js-content',
  POPOVER: (name) => `[data-centered-popover="${name}"]`,
};

elabs.CenteredPopovers = class {
  constructor(element) {
    if (!element) {
      console.error('CenteredPopovers: Main wrapper element not found.');
      return;
    }

    this.view = element;
    this.container = this.view.querySelector(SELECTOR.CONTAINER);
    this.overlay = this.view.querySelector(SELECTOR.OVERLAY);
    this.activePopover = null;

    if (!this.container || !this.overlay) {
      console.error('CenteredPopovers: Could not find .js-content or .js-overlay elements.');
      return;
    }

    this.view.style.display = 'flex';
    this.overlay.addEventListener('click', () => this.hide());
  }

  show({ name, payload = {}, triggerStopScroll = true } = {}) {
    if (!name) {
      return;
    }

    window.CenteredPopovers[name]?.show(payload);

    this.activePopover = name;

    const popoverElement = this.view.querySelector(SELECTOR.POPOVER(name));
    if (popoverElement) {
      popoverElement.classList.add('active');
    }

    this.view.classList.add('active');
    this.container.classList.add('active');

    if (triggerStopScroll) {
      this.addBodyClasses();
    }
  }

  hide() {
    if (!this.activePopover) {
      return;
    }

    const popoverElement = this.view.querySelector(SELECTOR.POPOVER(this.activePopover));

    setTimeout(() => {
      if (popoverElement) {
        popoverElement.classList.remove('active');
      }
    }, 300);

    this.view.classList.remove('active');
    this.container.classList.remove('active');
    this.removeClassBodyClasses();

    window.dispatchEvent(new CustomEvent('CenteredPopoversWrapper:hide'));
    window.CenteredPopovers[this.activePopover]?.hide();

    this.activePopover = null;
  }

  addBodyClasses() {
    document.body.classList.add('overflow-hidden', 'blur-content');
  }

  removeClassBodyClasses() {
    document.body.classList.remove('overflow-hidden', 'blur-content');
  }
};

elabs.onJavascriptReady(() => {
  const popoversWrapperElement = document.getElementById('ElCenteredPopovers');

  if (popoversWrapperElement) {
    window.CenteredPopovers = window.CenteredPopovers || {};
    window.CenteredPopovers['wrapper'] = new elabs.CenteredPopovers(popoversWrapperElement);
    window.__CenteredPopoversWrapperReady = true;
    window.dispatchEvent(new CustomEvent('CenteredPopoversWrapper:ready'));
  }
});
